module.exports = __webpack_public_path__ + "img/gra-account-mail.877b94b7.jpg";